export default {
  data() {
    return {

    }
  },
  created() {
    
  },
  methods: {
    beforeAvatarUpload(file) {
      console.log("文件上传之前",file)
			const isJPG = file.type === 'image/jpeg' || file.type === 'png'
			const isLt2M = file.size / 1024 / 1024 < 2
			if (!isJPG) { this.$message.error('上传图片只能是 JPG、PNG 格式!') }
			if (!isLt2M) { this.$message.error('上传图片大小不能超过 2MB!') }
			return isJPG && isLt2M
    },
    //图片上传成功回调
    imgAdd(response, file, fileList) {
      this.fileList = fileList;
      this.isMax = fileList.length >= 1;
      this.$message.success('上传成功！')
      this.imageUrl1 = URL.createObjectURL(file.raw);
      this.headImgId = JSON.parse(response.data).fileId
    },
    //套图图片上传成功回调
		imgArrAdd(response, file, fileList) {
      this.fileListArr = fileList;
      this.isArrMax = fileList.length >= 5;
      this.$message.success('上传成功！')
      this.imageUrl1 = URL.createObjectURL(file.raw);
      this.ImgIdArr.push( JSON.parse(response.data).fileId);
    },
    //图片上传失败
		error(err, file, fileList) {
			this.$message.error('上传失败')
			this.isMax = fileList.length >= 1;
    },
    //套图图片上传失败
		imgArrerror(err, file, fileList) {
      this.$message.error('上传失败')
			this.isArrMax = fileList.length >= 5;
    },
    //图片状态改变时触发
		change(file,fileList) {
      if (fileList.length >= 1) { this.isMax = true }
    },
    //套图图片状态改变时触发
		imgArrchange(file,fileList) {
      if (fileList.length >= 5) { this.isArrMax = true }
    },
    //图片预览
		handlePictureCardPreview(file) {
			this.imageUrl1 = file.url
			this.dialogVisible = true
    },
    //套图图片预览
		imgArrhandlePictureCardPreview(file) {
      this.imageUrl1 = file.url
			this.dialogVisible = true
    },
    //图片移除
		handleRemove(file, fileList) {
      this.fileList = fileList;
      this.headImgId=""
      if (fileList.length < 1) { this.isMax = false }
    },
    //套图图片移除
		imgArrhandleRemove(file, fileList) {
      this.ImgIdArr=[];
      fileList.forEach( Element => {
        if (Element.id) {
          this.ImgIdArr.push(Element.id)
        } else if (Element.response && Element.response.status === 0) [
          this.ImgIdArr.push( this.$api.imgUrl_ + Element.response.data)
        ]
      })
      if (fileList.length < 5) { this.isArrMax = false }
    },
  },
}